// Utility functions
export function isGraphQLError(error: any): error is {message: string; graphQLErrors?: any[]; networkError?: any} {
  return error && typeof error === 'object' && 'message' in error;
}

export function getErrorMessage(error: any): string {
  if (isGraphQLError(error)) {
    return error.message;
  }
  return error?.message || 'An unknown error occurred';
}
